import { classNames } from '@shared/lib/classNames'
import type { SwitchProps } from 'antd-mobile'
import { Switch } from 'antd-mobile'
import * as styles from './mobile-switch.module.scss'

interface MobileSwitchProps extends SwitchProps {
    alwaysChecked?: boolean
}

export const MobileSwitch = ({ alwaysChecked, ...props }: MobileSwitchProps) => {
    const className = classNames('', {
        [styles.alwaysChecked]: alwaysChecked
    })

    return <Switch className={className} {...props} />
}
